import { API_V1_URL } from './config';

type CampaignInfoResponse = {
  name: string;
  uuid: string;
  reward_amount: number;
  reward_existing_users: boolean;
  reward_claimed: boolean;
};

export type CampaignInfo = {
  name: string;
  uuid: string;
  rewardAmount: number;
  rewardExistingUsers: boolean;
  rewardClaimed: boolean;
};

export async function getCampaignInfo(
  campaignId: string
): Promise<CampaignInfo> {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const response = await fetch(`${API_V1_URL}campaigns/${campaignId}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Failed to fetch campaign info');
  }
  const data = (await response.json()) as CampaignInfoResponse;
  return {
    name: data.name,
    uuid: data.uuid,
    rewardAmount: data.reward_amount,
    rewardExistingUsers: data.reward_existing_users,
    rewardClaimed: data.reward_claimed,
  };
}

export type ClaimErrorResponse = {
  error:
    | 'ALREADY_CLAIMED'
    | 'CAMPAIGN_EXPIRED'
    | 'CAMPAIGN_DOESNT_REWARD'
    | 'ALREADY_CLAIMED_FROM_ANOTHER_CAMPAIGN';
};

export const claimReward = async (csUuid: string) => {
  const response = await fetch(`${API_V1_URL}campaigns/${csUuid}/claim`, {
    method: 'POST',
    credentials: 'include',
  });

  const data = await response.json();

  if (!response.ok) {
    return {
      ok: false,
      data: data as ClaimErrorResponse,
    };
  }
  return {
    ok: response.ok,
    data,
  };
};
